import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=f6e84bbc&scoped=true&lang=pug&"
import script from "./file-upload.vue?vue&type=script&lang=ts&"
export * from "./file-upload.vue?vue&type=script&lang=ts&"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=f6e84bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e84bbc",
  null
  
)

export default component.exports